import Fetcher from '../../../../services/Fetcher'
import {
  API_DICTIONARY,
  HTTP_METHODS,
  ResponseWithPagination
} from '../../../../constants'
import { CommunityUsersRequest, CommunityUsersResponse } from './types'
import { THealthSystem } from '../../../HealthSystems/types'

const fetcher = new Fetcher({})

export const getCommunityUsers = async (role: string | null, data) =>
  fetcher.request<CommunityUsersRequest, CommunityUsersResponse>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.USERS}${
      role ? role + '/' : ''
    }`,
    method: HTTP_METHODS.GET,
    ...data
  })
export const getListOfHospitals = async (role: string | null) =>
  fetcher.request<unknown, ResponseWithPagination<THealthSystem>>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.USERS}${
      role ? role + '/' : ''
    }${API_DICTIONARY.OPTIONS}${API_DICTIONARY.HOSPITALS}`,
    method: HTTP_METHODS.GET
  })

export const getListOfDepartments = async (role: string | null) =>
  fetcher.request<unknown, ResponseWithPagination<THealthSystem>>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.USERS}${
      role ? role + '/' : ''
    }${API_DICTIONARY.OPTIONS}${API_DICTIONARY.DEPARTMENTS}`,
    method: HTTP_METHODS.GET
  })
